import React from "react";
import AdminReferralsComponent from "../../../components/Admin/Referrals";

export default function AdminReferralsPage() {
    return <AdminReferralsComponent />;
}
